export enum ACTION_FIELD_TYPE {
  date = 'Date',
  text = 'Text',
  textarea = 'Textarea',
  file = 'File',
  switch = 'Switch',
  checkbox = 'Checkbox',
  select = 'Select',
  radioGroup = 'Radiogroup',
  number = 'Nubmer',
  // спец тип для текста
  textField = 'TextField',
}

export enum SUBMIT_SERVER_ACTION_TYPE {
  redirectToOrder = 'REDIRECT_TO_ORDER'
}

export enum SERVER_ACTION_LOCATION_TYPE {
  order = 'ORDER_BASE',
  createDocumentButton = 'CREATE_DOCUMENT_BUTTON',
  orderPayButton = 'PAYMENT_METHODS',
}

export enum SUBMIT_SERVER_ACTION_TAB {
  report = 'REPORT'
}

export enum VXLABEL_TYPE {
  text = 'TEXT',
  // на данный момент не используется фронтом, но приходит с бэка
  // resource = 'RESOURCE',
}
